/* eslint-disable unicorn/prefer-module */
import React, { useMemo } from "react";
import { useLocation, useNavigate, matchRoutes } from "react-router-dom";
import { APP_ROUTE_PATHS } from "../../constants";
import { useAuthContext } from "../../context/auth";
import { getParentPath } from "../../utils";
import styles from "./Header.module.scss";

// Set de rutas reales (espejo de App.js). Se arma una sola vez a nivel de módulo.
const ROUTE_OBJECTS = APP_ROUTE_PATHS.map((path) => ({ path }));
const isValidRoute = (candidate) => Boolean(matchRoutes(ROUTE_OBJECTS, candidate));

export const Header = ({
  children,
  leftContent,
  centerContent,
  logo: logoProp,
  expandChildren = false,
  onFloorClick,
}) => {
  const { pais } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  // El logo sube un nivel de la jerarquía de rutas (ancestro real más cercano, piso "/admin").
  // Si ya estás en el piso (el parent coincide con la ruta actual) no se navega: se delega en
  // `onFloorClick` si el caller lo provee (easter egg del saludo en /admin), o no hace nada.
  const handleLogoClick = () => {
    const parent = getParentPath(location.pathname, isValidRoute);
    if (parent === location.pathname) {
      if (typeof onFloorClick === "function") onFloorClick();
      return;
    }
    navigate(parent);
  };

  const logoDefault = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  const logo = logoProp || logoDefault;

  return (
    <div className={styles.headerContainer}>
      <div className={styles.leftGroup}>
        <img src={logo} alt={`${pais} Logo`} className={styles.logo} onClick={handleLogoClick} />
        {leftContent && <div className={styles.leftContent}>{leftContent}</div>}
      </div>
      {centerContent && <div className={styles.centerGroup}>{centerContent}</div>}
      {children && <div className={expandChildren ? styles.rightGroupExpanded : styles.rightGroup}>{children}</div>}
    </div>
  );
};
